// extracted by mini-css-extract-plugin
export default {"footer":"PublicFooter-module__footer--_aJ02","animatedBackground":"PublicFooter-module__animatedBackground--X7wPi"};